import { findIntegrationByProviderInEntities } from '@vy/services';
import type { AnrokProductEntity, BaseIntegrationEntity, CatalogProducts } from '@vy/types';
import { INTEGRATION_PROVIDERS } from '@vy/types';
import { isNotNullOrUndefined } from '@vy/utils';

type AnrokResolvableProduct = {
  integrationEntities?: BaseIntegrationEntity[] | null;
  catalogProductId?: string | null;
};

export type ResolvedAnrokFields = {
  anrokId: string | undefined;
  anrokOverrideId: string | undefined;
  anrokCatalogDefaultId: string | undefined;
};

export function resolveAnrokFields(
  product: AnrokResolvableProduct,
  catalogProductsById?: Map<string, CatalogProducts>,
): ResolvedAnrokFields {
  const contractAnrok = findIntegrationByProviderInEntities<AnrokProductEntity>(
    product.integrationEntities ?? [],
    INTEGRATION_PROVIDERS.anrok,
  );
  const anrokOverrideId = contractAnrok?.metadata?.productId ?? contractAnrok?.integrationExternalId;

  const catalogProduct = isNotNullOrUndefined(product.catalogProductId) && isNotNullOrUndefined(catalogProductsById)
    ? catalogProductsById.get(product.catalogProductId)
    : undefined;
  const catalogAnrok = findIntegrationByProviderInEntities<AnrokProductEntity>(
    catalogProduct?.integrationEntities ?? [],
    INTEGRATION_PROVIDERS.anrok,
  );
  const anrokCatalogDefaultId = catalogAnrok?.metadata?.productId ?? catalogAnrok?.integrationExternalId;

  const anrokId = anrokOverrideId ?? anrokCatalogDefaultId;

  return { anrokId, anrokOverrideId, anrokCatalogDefaultId };
}